export default __webpack_public_path__ + "static/media/civilno-drustvo-i-eu.441b6d6b.svg";